import React from 'react';
import { observer } from 'mobx-react';
import ManageRawGenericExportMappingComponentVM from './ManageRawGenericExportMappingComponentVM';
import { Neo } from '@singularsystems/neo-react';
import { TextConstants } from '../../../Common/TextConstants';
import { ModalUtils, Validation } from '@singularsystems/neo-core';

interface IManageRawGenericExportMappingComponentProps {
    viewModel: ManageRawGenericExportMappingComponentVM;
    onCancel: () => void;
    onSave: () => void;
}

@observer
export default class ManageRawGenericExportMappingComponent extends React.Component<IManageRawGenericExportMappingComponentProps> {

    public render() {
        var viewModel = this.props.viewModel;
        return (
            <>
                {<Neo.Card title={`${viewModel.managedGenericMapping.rawGenericExportMappingId === 0 ? TextConstants.Titles.AddGenericExportMapping : TextConstants.Titles.EditGenericExportMapping}`}>
                    <div>
                        <Neo.Form model={viewModel.managedGenericMapping}
                            onSubmit={() => this.props.onSave()}
                            validationDisplayMode={Validation.DisplayMode.AfterSubmit}
                            onInvalid={this.onFormInvalid}>
                           <Neo.GridLayout lg={4}>
                                <Neo.FormGroup
                                    label={TextConstants.Labels.TableColumnName} >
                                    <Neo.AutoCompleteDropDown
                                        itemSource={viewModel.staticExportColumnSpecApiClient.getExportColumnSpecsListAsync}
                                        bind={viewModel.managedGenericMapping.meta.staticExportColumnSpecId}
                                        bindDisplay={viewModel.managedGenericMapping.meta.columnName}
                                        displayMember={"fieldName"}
                                        readOnly={viewModel.isFieldReadOnlyInd}
                                        items={viewModel.staticExportColumnSpecApiClient.getExportColumnSpecsListAsync(" ", viewModel.staticExportFileSpecId).then((arr) => arr.data.slice(0, 10)
                                            .sort((x, y) => x.fieldName!.localeCompare(y.fieldName!)))}
                                    />
                                    </Neo.FormGroup>
                               <Neo.FormGroup 
                                    label={TextConstants.Labels.ReportColumnName}
                                    bind={viewModel.managedGenericMapping.meta.displayName}
                               />
                               <div className="col pt-4">
                                    <Neo.FormGroup 
                                            bind={viewModel.managedGenericMapping.meta.isExcluded}
                                            input={{ type: "switch" }}
                                            label={TextConstants.Labels.Excluded} />
                               </div>
                            </Neo.GridLayout>
                            <div className="row customMarginTop29 float-right pr-3">
                                <Neo.Button 
                                    variant="primary" className="ml-3 col-md-2" isSubmit
                                >{TextConstants.Buttons.Save}</Neo.Button>
                                <Neo.Button className="ml-3 col-md-2"
                                    onClick={() => this.props.onCancel()}
                                    variant="secondary"
                                >{TextConstants.Buttons.Cancel}</Neo.Button>
                            </div>
                        </Neo.Form>
                    </div>
                </Neo.Card>

                }
            </>
        );
    }

    private onFormInvalid(e: React.FormEvent, justValidated?: boolean) {
        if (!justValidated) {
            ModalUtils.showMessage("Save", TextConstants.Validation.InvalidGenericMapping);
        }
    }
}